var map = {
	"./admin.png": "125c",
	"./attention-1.png": "a83a",
	"./attention.png": "e0d7",
	"./avater.png": "a75f",
	"./cover.png": "b39f",
	"./doctor.png": "2640",
	"./doctorDetail.png": "54b9",
	"./play.png": "9365",
	"./trophy.png": "2330",
	"./video.png": "25c3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e886";